/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_AltInputs */

const en_gc_search_guides_what_is_gridcraft_sections_2_figure_alt = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft PivotTable grouping sales revenue by region and product`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_2_figure_alt = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 数据透视表按区域和产品汇总销售收入`)
};

/**
* | output |
* | --- |
* | "GridCraft PivotTable grouping sales revenue by region and product" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_2_figure_alt = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Figure_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_2_figure_alt(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_2_figure_alt(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_2_figure_alt as "gc.search_guides.what_is_gridcraft.sections.2.figure.alt" }